import React, {useState} from "react";
import { StyleSheet, Text, View, Button,TextInput,ActivityIndicator } from "react-native"
import firebase from './database/firebase';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

var items = ['about a heated argument you recently had with a family member.', 'about a bad experience with an employer or teacher.', 'explaining your opinion about a political controversy.'];
var item = items[Math.floor(Math.random() * items.length)];
    //const urlParams = new URLSearchParams(props.location.search);
	//const myParam = urlParams.get('uid');
	const queryString = window.location.search;
	//alert(queryString);
	const urlParams = new URLSearchParams(queryString);
	const user_id = urlParams.get('uid');


function writeUserData(userId,paragraph, time,prompt) {
	firebase.database().ref('posts_edit_high/' + userId+'_'+time).set({
		time: time,
		secondprompt:prompt,
		post: paragraph,
		userId: userId,
	});
  }

  const writeUserPost = async (userId,paragraph, time,prompt) => {  
	firebase.database().ref('final_posts_edit_high/' + userId+'_'+time).set({
		time: time,
		firstprompt:prompt,
		post: paragraph,
		userId: userId,
	});
  }


const Main2 = (props) => {
   
  const [post, setPost] = useState(props.navigation.state.params.detail);  
  const [attempts, setAttempts] = useState(3); 
  const [loading,setLoading]=useState(false);
  if(loading ===true){
	return(
		<View style={styles.container}>
			<Text style={styles.label2}>Checking the language used to write the post.....</Text> 
	  <View style={styles.preloader}>
		

		<CountdownCircleTimer
			isPlaying
			duration={7}
			colors={['#004777', '#F7B801', '#A30000', '#A30000']}
			colorsTime={[7, 5, 2, 0]}
		>
			{({ remainingTime }) => remainingTime}
		</CountdownCircleTimer>
		
	  </View>
	  </View>
	)
  } 
  else{
		return(
			<div>
				
				<View style={styles.container}>
					<Text style={styles.text}>Write a post in {props.navigation.state.params.language} language {item} (Please write a post of at least 4-6 sentences.)</Text>
					<View style={styles.textAreaContainer} >
					
						<TextInput
						style={styles.textArea}
					
						placeholder="What's on your mind?"
						placeholderTextColor="grey"
						numberOfLines={48}
						//editable = {false}
						multiline={true}
						//value={post}
						onChangeText={post => {setPost(post)
							writeUserData(user_id,post,new Date().toString(),item)}}>
							{post}
						</TextInput>
					</View>
					<View style={styles.buttonContainer}>

					<Button 
					color='#341ada'
					title="Next"
					style={StyleSheet.buttonStyle}
					onPress={() => { if(post === null){
						if(attempts === 1){
							alert("Writing the post is mandatory! This is your last chance!");
							setAttempts(attempts-1);
						}
						else if(attempts === 0){
							props.navigation.navigate('Fin');
						}
						else{
							alert("Writing the post is mandatory!");
							setAttempts(attempts-1);
						}
					}
					else{	
						setLoading(true);
							writeUserPost(user_id,post,new Date().toString(),item).then((r)=>{
							})
							.catch((err) => {
								console.log('error'+err);
							});
							//alert('2abl ma yerou7'+tara);
							setTimeout(() => {
							
								props.navigation.navigate('Beforeaftermain2', {translatedpost: "", originalpost: post, language: props.navigation.state.params.language,uid:user_id,secondtopic:item});  	
								setLoading(false);
							}, 7000); 
						
									}	
				}}

					> 
					</Button>
					</View>
					
				</View>
			</div>
		)
	}
}
const styles = StyleSheet.create({
	container: {
		padding: 50,
		flex: 1,
		display: "flex",
		marginTop: 20,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
	},
	buttonContainer:{
		width: '20%',
		alignSelf: 'center',
		marginVertical: 20,
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:300,
		paddingLeft: 300,
		paddingBottom: 30,

	  },
	  label2: {
        //margin: 8,
        fontWeight: "bold",
        fontSize: 25,
      },
	  preloader:{
		flex: 1,
		display: "flex",
		marginTop: 20,
		marginBottom: 20,
		textAlign: 'center',
		alignSelf: 'center',
		flexDirection: "column",
		justifyContent: "center",
	  },
	  textArea: {
		height: 300,
		fontSize: 20,
		borderColor: '#341ada',
		borderWidth: 3,
		justifyContent: "flex-start"
	  }
})
export default Main2
//alert("Please write the post in a language other than English.");